import Image from 'next/image';
import { useEffect, useState } from 'react';
import { SizeGuideItemProps } from './constants';


interface SizeGuideProps {
  size_guide: SizeGuideItemProps;
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
}

const SizeGuide = (props: SizeGuideProps) => {
  const { size_guide, isVisible, setIsVisible } = props;
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(isVisible)
  }, [setIsOpen, isVisible])

  useEffect(() => {
    isOpen ? (document.body.style.overflow = 'hidden') : (document.body.style.removeProperty('overflow'));
  }, [isOpen])

  const render_data = (title: string | undefined, content: string | undefined) => {
    return (
      <table className="min-w-full mt-4 text-sm border border-solid font-poppins border-sizeGuideTableBorder">
        {title !== undefined && (<thead className="text-white bg-sizeGuideHeaderBg">
          <tr>
            {title.split(",").map((text, index) => {
              return (
                <th key={index} className="px-6 py-2 text-center border border-solid whitespace-nowrap border-sizeGuideTableBorder">
                  {text}
                </th>
              )
            })}
          </tr>
        </thead>)}
        {content !== undefined && (<tbody className="bg-sizeGuideContentBg">
            {content.split("\r\n").map((size, index) => {
              return (
                <tr key={index}>
                  {size.split(",").map((text, index) => {
                    return (
                      <td
                        key={index}
                        className={`px-6 py-2 text-center whitespace-nowrap border border-sizeGuideTableBorder border-solid`}
                        rowSpan={text.includes("$RS") ? parseInt(text.split('$RS')[1].split('$')[0]) : 1}
                        colSpan={text.includes("$CS") ? parseInt(text.split('$CS')[1].split('$')[0]) : 1}
                      >
                        {text.includes("$RS") || text.includes("$CS") ? text.trim().slice(5) : text}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
        </tbody>)}
      </table>
    )
  }

  const render_measure = (prompt: string, title: string | undefined, content: string | undefined, data : Array<{title: string, content: string}> | undefined) => {
    return (
      <div className="w-full mt-4">
        {prompt !== null && prompt.length > 0 && (
          <div className="text-sm text-black font-poppins">{prompt}</div>
        )}
        {/* {((title !== undefined && title.length > 0) || (content !== undefined && content.length > 0)) && (<div className="w-full overflow-x-auto">
          {render_data(title, content)}
        </div>)} */}
        {data !== undefined && data.length > 0 && data.map((dd, index) => (
          <div className="w-full overflow-x-auto" key={index}>
            {render_data(dd.title, dd.content)}
          </div>)
        )}
      </div>
    )
  }

  return (
    <>
      <div
        className={`${isOpen ? "fixed left-0 w-screen h-screen top-0 right-0 bottom-0 bg-black opacity-30 z-[54]" : ""}`}
        onClick={() => {
          setIsOpen(!isOpen);
          setIsVisible(!isVisible);
        }}
      ></div>
      <div
        className={`fixed w-full md:w-[468px] z-[55] bg-white top-0 h-dscreen transition-transform ease-in-out duration-300 transform inset-y-0 -right-[100%] md:-right-[468px] py-8 px-6 ${isOpen ? '-translate-x-full' : 'translate-x-0'}`}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/size-guide.png"}
              alt="size guide icon"
              quality={100}
              width={20}
              height={20}
              className=""
            />
            <p className="ml-4 text-sm font-bold text-black font-poppins">Size Guide</p>
          </div>
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/close.png"}
            alt="close icon"
            width={14}
            height={14}
            quality={100}
            onClick={() => {
              setIsOpen(!isOpen);
              setIsVisible(!isVisible);
            }}
            className="cursor-pointer"
          />
        </div>
        <hr className="border-t-[1px] border-solid border-sku my-4 md:my-8" />
        <div className="w-full pr-2 overflow-y-auto size-guide-height">
          <div>
            <div className="text-xl font-bold text-black font-poppins">Rincian Ukuran</div>
            {size_guide.image !== null && size_guide.image !== undefined && size_guide.image.length > 0 && (<div className="flex justify-center mt-2">
              <Image
                src={size_guide.image}
                alt="measure desc image"
                width={250}
                height={250}
                quality={100}
                className="max-w-[250px] h-auto"
              />
            </div>)}
            {size_guide.measure !== null && size_guide.measure !== undefined &&
              ((size_guide.measure.prompt !== null && size_guide.measure.prompt.length > 0) ||
                (size_guide.measure.title !== undefined && size_guide.measure.title.length > 0) ||
                (size_guide.measure.content !== undefined && size_guide.measure.content.length > 0) ||
                (size_guide.measure.data !== undefined && size_guide.measure.data.length > 0)) && (
              render_measure(size_guide.measure.prompt, size_guide.measure.title, size_guide.measure.content, size_guide.measure.data)
            )}
            {size_guide.suggestion !== null && size_guide.suggestion !== undefined &&
              ((size_guide.suggestion.prompt !== null && size_guide.suggestion.prompt.length > 0) ||
                (size_guide.suggestion.title !== undefined && size_guide.suggestion.title.length > 0) ||
                (size_guide.suggestion.content !== undefined && size_guide.suggestion.content.length > 0) ||
                (size_guide.suggestion.data !== undefined && size_guide.suggestion.data.length > 0)) && (
              render_measure(size_guide.suggestion.prompt, size_guide.suggestion.title, size_guide.suggestion.content, size_guide.suggestion.data)
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default SizeGuide
